module.exports = __webpack_public_path__ + "static/media/8900_MasterBathroom.54f1b5e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/8900_MasterBathroom.jpg
// module id = 580
// module chunks = 0